'use strict';

const jQuery = require('jquery');
const Mediator = require('./../../../core/mediator');

const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');
const DndZone = require('./../service/dndZone');
const ResizeColumn = require('./../service/resizeColumn');
const appender = require('./../service/appender');
const Loader = require('./../../../services/loader');
const TranslateContent = require('./../service/translateContent');

const getAddZone = ($zone) => {
    let $addZone = $zone;

    if ($addZone.hasClass('cloud-dnd')) {
        return $zone;
    }

    if ($addZone.hasClass('top') || $addZone.hasClass('bottom')) {
        $addZone = $zone.parents('.bb-content:first')[$zone.hasClass('top') ? 'prev' : 'next']('.cloud-dnd');

        if (!$addZone.length) {
            $addZone = $zone.parents('.cloudcontentset')[$zone.hasClass('top') ? 'prev' : 'next']('.cloud-dnd');
        }
    }

    return $addZone;
};

module.exports.onDrop = function(config) {
    let content = ContentManager.getContentByNode(jQuery(config.ui.draggable));
    let $zone = getAddZone(jQuery(config.event.target));
    let direction = $zone.hasClass('vertical') ? 'vertical' : 'horizontal';
    let contentSet = ContentManager.getContentByNode($zone.parents('.bb-content:first'));

    config.prev = $zone.prev(':not(.ghost-dnd, .cloud-dnd)');
    config.next = $zone.next(':not(.ghost-dnd, .cloud-dnd)');
    config.$zone = $zone;

    if ($zone.hasClass('horizontal-between')) {
        config.prev = $zone.prevAll('.bb-content:first:not(.ghost-dnd, .cloud-dnd)');
        config.next = $zone.nextAll('.bb-content:first:not(.ghost-dnd, .cloud-dnd)');
    }

    content.$.addClass('send-request');

    Loader.start();

    if (null !== contentSet && contentSet.isContentSet()) {
        appender[direction](contentSet, content, config).done(function() {
            ContentManager.refreshjQueryObject(content);
            TranslateContent.applyOnChange(content);

            SaveManager.save().done(function() {
                content.$.find('img').on('load', function() {
                    setTimeout(function() {
                        DndZone.apply();
                    }, 0);
                });

                content.removeClass('d-none send-request');

                Mediator.publish('after:content:drop', content);

                Mediator.publish('after:' + content.type + ':drop', content);

                ContentManager.removeStylesFromDnd();

                DndZone.apply();
                ResizeColumn.apply();

                Loader.stop();
            });
        });
    }
};

module.exports.onDragStart = function(config) {
    let $target = jQuery(config.event.currentTarget);
    let $colContentSet = $target.parents('.colcontentset:first');
    let $fakeContent;

    jQuery('body').addClass('cloud-dragging');
    $target.addClass('d-none');

    if ($colContentSet.children('.bb-content').not('.ghost-dnd').length > 1) {
        $fakeContent = jQuery('<div class="ghost-content"></div>');

        $fakeContent.css('height', $target.data('dnd-height'));
        $fakeContent.addClass('ghost');

        $target.after($fakeContent);
    } else {
        $colContentSet.css('height', $target.data('dnd-height'));
        $colContentSet.addClass('ghost');
    }

    ResizeColumn.unApply();
};

module.exports.onDragStop = function(config) {
    let $colContentSet = jQuery(config.event.target).parents('.colcontentset:first');

    $colContentSet.removeClass('ghost').removeAttr('style');

    jQuery('.ghost-content').remove();
    jQuery('body').removeClass('cloud-dragging');

    ResizeColumn.apply();
};
